import { TableRow } from "@carbon6/c6-frontend-design";
import type { DatasetCameraDetails } from "@/api/datasetTrainingOverview";
import { formatBytes, formatNumber } from "@/utils";
import { formatDuration } from "@/utils/datetime";

/** c6 정적 표가 읽는 표시 행. 미측정 값은 열마다 따로 `—` 로 표시한다. */
export class CameraRow extends TableRow {
  readonly camera: string;
  readonly probe: string;
  readonly resolutions: DatasetCameraDetails["resolutions"];
  readonly fps: string;
  readonly codecs: string;
  readonly frames: string;
  readonly duration: string;
  readonly files: string;
  readonly size: string;
  readonly masks: string;
  constructor(camera: DatasetCameraDetails) {
    super();
    this.camera = camera.camera;
    this.probe = `${formatNumber(camera.probed_video_count)} / ${formatNumber(camera.video_count)}`;
    this.resolutions = camera.resolutions;
    this.fps = camera.fps_values.length ? camera.fps_values.join(", ") : "—";
    this.codecs = camera.codecs.length ? camera.codecs.join(", ") : "—";
    this.frames = camera.total_frame_count === null ? "—" : formatNumber(camera.total_frame_count);
    this.duration = formatDuration(
      camera.total_duration_seconds === null ? null : camera.total_duration_seconds * 1000,
    );
    this.files = formatNumber(camera.file_count);
    this.size = formatBytes(camera.total_size_bytes, "—");
    this.masks = formatNumber(camera.mask_count);
  }
  getRowId(): string {
    return this.camera;
  }
  canShow(): boolean {
    return true;
  }
  canSelect(): boolean {
    return false;
  }
}
